import { clientFactory } from './factories';
import { AuthorizationModuleCoreClient } from './implementations/core/client';
import { AuthorizationModuleCustomClient } from './implementations/custom/client';

export const AuthorizationModuleClient = clientFactory(AuthorizationModuleCoreClient, AuthorizationModuleCustomClient);
